<div class="phone-country-code-selector">
  <label *ngIf="label" class="selector-label" [attr.for]="triggerId">
    {{ label }}
    <span *ngIf="required" class="required-mark">*</span>
  </label>

  <button
    type="button"
    class="selector-trigger"
    [id]="triggerId"
    [class.open]="isOpen"
    [disabled]="disabled"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="dialog"
    (click)="toggleDropdown($event)">
    <span class="selector-value" [class.placeholder]="!selectedCountryCode">
      {{ getDisplayValue() }}
    </span>
    <span class="selector-arrow" [class.open]="isOpen" aria-hidden="true">
      <svg viewBox="0 0 24 24">
        <path d="M7 10l5 5 5-5z"/>
      </svg>
    </span>
  </button>

  <div class="selector-dropdown" *ngIf="isOpen">
    <div class="search-box">
      <input
        #searchInput
        type="text"
        [(ngModel)]="searchText"
        (ngModelChange)="onSearchChange()"
        placeholder="Search country or code..."
        class="search-input"
        (click)="$event.stopPropagation()">
      <div class="search-icon">🔍</div>
    </div>

    <div class="options-list">
      <div *ngIf="filteredCountryCodes.length === 0" class="no-results">
        No countries found
      </div>

      <div *ngFor="let countryCode of filteredCountryCodes"
           class="option-item"
           [class.selected]="selectedCountryCode?._id === countryCode._id"
           (click)="selectCountryCode(countryCode)">
        <span class="flag">{{ countryCode.flagIcon }}</span>
        <span class="country-name">{{ getCountryName(countryCode) }}</span>
        <span class="phone-code">{{ countryCode.phoneCountryCode }}</span>
      </div>
    </div>
  </div>
</div>

